// The ring. `sm` sits inside a .btn ("<Spinner size="sm" /> Saving…"); `md` stands alone.
type Props = {size?: 'sm' | 'md'; label?: string; className?: string};

export default function Spinner({size = 'md', label = 'Loading', className = ''}: Props) {
    const dims = size === 'sm' ? 'h-[18px] w-[18px] border-2' : 'h-8 w-8 border-[3px]';
    return (
        <span
            role="status"
            aria-label={label}
            className={`inline-block shrink-0 animate-spin rounded-pill border-current border-t-transparent opacity-60 ${dims} ${className}`}
        />
    );
}
